import { useMemo } from 'react';
import useAnalytics from 'hooks/useAnalytics';
import Forbidden from 'pages/error/Forbidden';
import { Container } from './Analytics.styles';
import AnalyticsAndHostingQualityWrapper from './AnalyticsAndHostingQualityWrapper';

const Analytics = () => {
  const analyticsAndHostingQualityWrapper = useMemo(
    () => <AnalyticsAndHostingQualityWrapper />,
    [],
  );
  const showAnalytics = useAnalytics();

  if (!showAnalytics) {
    return <Forbidden />;
  }

  return <Container>{analyticsAndHostingQualityWrapper}</Container>;
};

export default Analytics;
